export default __webpack_public_path__ + "static/network_codebook-85148d8c57bb89681db56168d565caa9.pdf";